export default __webpack_public_path__ + "static/media/im-icon-active.15a5ed66.svg";